import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { Link } from "react-router-dom";

const DisclaimerPage = ()=>{
    return(
        <div>
            <BreadcrumbComponent home='Home' listOne="Disclaimer" />
            <div className={Style.pageTitle + ' ' + Style.marginUp40 + ' ' + Style.disclaimerPage}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Disclaimer</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={Style.aboutmayocollege + ' ' + Style.pageBoder}>
                                <p>Thank you for visiting the Mayo College Alumni Association Delhi website and engaging with our services. By accessing our website or participating in our events, you agree to the terms outlined in this disclaimer.</p>
                                <h3>General Information:</h3>
                                <p>The information provided on our website and during association events is for general informational purposes only.</p>
                                <h3>Accuracy of Information:</h3>
                                <p>While we strive to ensure the accuracy of the information presented, Mayo College Alumni Association Delhi makes no warranties or representations regarding the completeness, accuracy, or reliability of any information on our website.</p>
                                <h3>Event Participation:</h3>
                                <p>Participation in association events is voluntary, and attendees acknowledge and assume any risks associated with participation.</p>
                                <h3>Third-Party Links:</h3>
                                <p>Our website may contain links to third-party websites. We are not responsible for the content, accuracy, or privacy practices of these external sites. Please review the terms and pol of such sites.</p>
                                <h3>Event Changes:</h3>
                                <p>Mayo College Alumni Association Delhi reserves the right to modify or cancel events at any time. Changes will be communicated through appropriate channels.</p>
                                <h3>Member Submissions:</h3>
                                <p>Content submitted by Association members, including but not limited to articles, photos, and comments, reflects the views of the individual members and not necessarily those of Mayo College Alumni Association Delhi.</p>
                                <h3>Privacy:</h3>
                                <p>Please refer to our Privacy Policy for information on how we collect, use, and protect your personal information.
                                </p>
                                <h3>Amendments to Disclaimer:</h3>
                                <p>Mayo College Alumni Association Delhi may update this disclaimer from time to time. Any changes will be effective immediately upon posting on our website.</p>
                                <h3>Contact Information:</h3>
                                <p>If you have any questions or concerns regarding this disclaimer, please contact us at <strong><Link to='mailto:secretary@mayoalumni.in'>secretary@mayoalumni.in</Link></strong>.</p>
                                <p>By accessing and using the Mayo College Alumni Association Delhi website or participating in our events, you acknowledge that you have read, understood, and agreed to the terms of this disclaimer.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default DisclaimerPage;